import { EventSubscriber } from '@verdant-web/common';
export class Heartbeat extends EventSubscriber {
    get interval() {
        return this._interval;
    }
    constructor({ interval = 15 * 1000, deadlineLength = 3 * 1000, restartOnTabFocus = true, } = {}) {
        super();
        this.nextBeat = null;
        this.deadline = null;
        this.keepAlive = () => {
            if (this.deadline) {
                clearTimeout(this.deadline);
                this.deadline = null;
                this.start();
            }
        };
        this.start = (immediate = false) => {
            this.stop();
            if (immediate) {
                this.beat();
            }
            else {
                this.nextBeat = setTimeout(this.beat, this._interval);
            }
        };
        this.stop = () => {
            if (this.nextBeat) {
                clearTimeout(this.nextBeat);
            }
            if (this.deadline) {
                clearTimeout(this.deadline);
            }
        };
        this.beat = async () => {
            this.emit('beat');
            this.deadline = setTimeout(this.onDeadline, this.deadlineLength);
        };
        this.onDeadline = () => {
            this.deadline = null;
            this.emit('missed');
        };
        /**
         * Only takes affect after the next beat
         */
        this.setInterval = (interval) => {
            this._interval = interval;
        };
        this._interval = interval;
        this.deadlineLength = deadlineLength;
        if (typeof window !== 'undefined' && restartOnTabFocus) {
            window.addEventListener('pageshow', () => this.start(true));
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    this.start(true);
                }
            });
        }
    }
}
//# sourceMappingURL=Heartbeat.js.map